/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AssessmentTaskKeyComponent = {
  id?: number
  taskKey?: AssessmentTaskKeyComponent.taskKey
}
export namespace AssessmentTaskKeyComponent {
  export enum taskKey {
    ACT_FR_COVEBO = 'act_fr_covebo',
    ACT_CR_COVEBO = 'act_cr_covebo',
    BOOKTHAT_PC_OC_R = 'bookthat_pc_oc_r',
    FORM_CW_ADAP_JE = 'form_cw_adap_je',
    BOOKTHAT_FORM_CW_ADAP = 'bookthat_form_cw_adap',
    PERSONAL_COLORS_COVEBO = 'personal_colors_covebo',
  }
}
